import { memo } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { RedesignModalShell } from 'root/src/client/v2/common/components/RedesignModalShell';
import { Button } from 'root/src/client/v2/common/components/ui/button';
export const RedesignPendingProjectModal = memo(() => {
    const modal = useRedesignModal();
    return (<RedesignModalShell className="sm:max-w-sm">
			<div className="flex flex-col items-center gap-4 text-center">
				<div className="flex h-14 w-14 items-center justify-center rounded-full bg-neon-green/10">
					<CheckCircleIcon sx={{ fontSize: 32 }} className="text-neon-green"/>
				</div>
				<h2 className="font-display text-xl font-bold text-foreground">Success</h2>
				<p className="text-sm text-muted-foreground">
					Your dare is waiting for admin approval. Your reward will be sent once an administrator approves it.
				</p>
				<Button variant="brand" onClick={() => modal.hide()} className="w-full max-w-[200px] rounded-lg text-sm font-semibold">
					OK
				</Button>
			</div>
		</RedesignModalShell>);
});
